import type { LiveSessionSessionType, SessionCategory } from './scheduledSessionStorage';

const WORKSHOP_CATEGORIES: SessionCategory[] = ['workshop_online', 'workshop_onsite'];

export function isWorkshopCategory(
  category: SessionCategory | string | undefined,
): category is 'workshop_online' | 'workshop_onsite' {
  return category === 'workshop_online' || category === 'workshop_onsite' || category === 'workshop';
}

export function normalizeSessionCategory(
  category: string | undefined,
  liveSessionType: LiveSessionSessionType = 'online',
): SessionCategory {
  if (category === 'workshop') {
    return liveSessionType === 'online' ? 'workshop_online' : 'workshop_onsite';
  }
  if (
    category === 'mandatory' ||
    category === 'optional' ||
    category === 'workshop_online' ||
    category === 'workshop_onsite'
  ) {
    return category;
  }
  return 'mandatory';
}

export function categoryToLiveSessionType(category: SessionCategory): LiveSessionSessionType {
  if (category === 'workshop_online') return 'online';
  if (category === 'workshop_onsite') return 'offline';
  if (category === 'optional') return 'tracking';
  return 'online';
}

export function workshopCategories(): SessionCategory[] {
  return [...WORKSHOP_CATEGORIES];
}
